import { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col, Image} from "react-bootstrap";
import { Rates } from "rate-quotes";
import "../App.css";
import SWlogo from "../images/42-Years-Of-Trust_White 1.png";
import Navbar from "react-bootstrap/Navbar";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index.js";

const Contact = lazy(() => import("./Contact"));

export default function Body() {
  const imgCDNURL = process.env.REACT_APP_CASHOUT_CDN_URL;
  const [navbar, setNavbar] = useState(false);

    useEffect(() => {
        const changebackground = () => {
            setNavbar(window.scrollY >= 9);
        };
        window.addEventListener('scroll', changebackground);
        return () => window.removeEventListener('scroll', changebackground);
    }, []);

  return (
    <Container fluid className="bgContainer"  >
      <Row className='hdr'>
        <Col sm={12} lg={7} xl={7} md={12} className="bgmobile">
          {/* <div className="logo text-center">
            <Image
              src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
              fluid
              alt="Sun West Mortgage Logo"
              className="SunWestLogo"
            />
            <Image
              src={SWlogo}
              fluid
              alt="Sun West Mortgage Logo"
              className="whitelogo mt-5 d-xl-none d-lg-none"
            />
          </div> */}
          <Row>
                    <Col>
                    <Navbar
                        collapseOnSelect
                        expand="lg"
                        fixed="top"
                        bg="dark"
                        variant="dark"
                        className={navbar ? 'navbar active' : 'navbar'}
                    >
                        <Navbar.Brand>
                        <div className="logo-container">
                            <a href="https://www.swmc.com/">
                                <img
                                    src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
                                    className="main_logo"
                                    alt="swmc-logo"
                                />
                           
                            </a>
                            </div>
                        </Navbar.Brand>
                        <UserWayAccessibilityMenu color="black" width={40} height={40} />
                    </Navbar>
                    </Col>
                    </Row>
          <div className="text-center">
            <div className="HomePrice">
              Take Advantage of the
              <br /> Equity in Your Home!
            </div>
          </div>
          <div className="skyrocketing text-center">
            With skyrocketing home prices, a Cash-Out Refinance can <br />
            help you unlock your equity to meet a variety of needs.
            <br />
            Additionally, you may also be able to reduce your interest rate.
          </div>
        </Col>
        <Col
          sm={12}
          lg={12}
          xl={12}
          md={12}
          className=" d-md-block d-lg-none mt-4"
        >
          <div className="SunWest-offer-container">
            <div className="SunWest-offer">
              <span>FICO as low as 500</span>
            </div>
          </div>
          <div className="HomePrice2">Work With Industry Experts! </div>
          <div className="skyrocketing1">
            Take advantage of years <br></br> of experience. Let us do <br></br>
            the heavy lifting.
          </div>
        </Col>

        <Col sm={12} lg={5} xl={5} md={12} className="ps-0 pe-0 mt-5">
          <Suspense fallback={null}>
            <Contact />
          </Suspense>
        </Col>

        <Col sm={12} lg={12} xl={12} md={12} className="pt-5">
          <Rates 
          leadSource="INHNPORT-017" 
          loanOfficerUid="CKTC"
          />
        </Col>

        <Col className=" mt-5 text-align-center">
          <div id="hidecontent" className="SunWest-offer-container">
            <div className="SunWest-offer">
              <span>FICO as low as 500</span>
            </div>
          </div>
          <div className="extra-content pb-5">
            <div className="HomePrice2 text-align-center">
              Work With Industry Experts!{" "}
            </div>
            <div className="skyrocketing1 text-center">
              Take advantage of years of experience. Let us do the heavy
              lifting.
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
